import { type FC } from "react";
import { type ProductData } from "~/domains/product/types/ProductData";
import PreviewTableMaterialIdInput from "~/features/bulkAddToCart/components/PreviewTable/PreviewTableMaterialIdInput";
import { useBooleanState } from "~/common/hooks/useBooleanState";
import { useTranslation } from "react-i18next";
import { C_PRIMARY } from "~/common/components/icon/Colors";
import { styled } from "~/common/mui";
import StarIcon from "@mui/icons-material/Star";

interface Props {
  value: string;
  isPreferred?: boolean;
  onChange: (product: ProductData) => void;
  disabled?: boolean;
}

const StyledPreviewTableMaterialIdInput = styled(PreviewTableMaterialIdInput)<{
  $applyPreferredStyles?: boolean;
}>(({ $applyPreferredStyles }) => ({
  ...($applyPreferredStyles && {
    "& .MuiOutlinedInput-root": {
      paddingLeft: "23px !important",
    },
  }),
}));

export const WishlistMaterialIdInput: FC<Props> = (props) => {
  const { t } = useTranslation();

  const { val: isFocused, setTrue: setFocused, setFalse: setUnfocused } = useBooleanState(false);

  const isPreferred = props.isPreferred;

  return (
    <div className={"p-relative"}>
      <StyledPreviewTableMaterialIdInput
        $applyPreferredStyles={!isFocused && isPreferred}
        label={t("wishlistPage.table.header.designation")}
        onFocus={setFocused}
        onBlur={setUnfocused}
        helperText={" "}
        startAdornment={isPreferred && !isFocused && <StarIcon style={{ color: C_PRIMARY }}  />}
        {...props}
      />
    </div>
  );
};
export default WishlistMaterialIdInput;
